<template>
    <v-dialog v-model="shows" width="320">
        <template #activator="{ attrs, on }">
            <v-btn small outlined color="primary" class="mr-2" v-bind="{ ...attrs, loading }" v-on="on">교환요청</v-btn>
        </template>
        <v-card>
            <v-card-title class="subtitle-1">교환요청</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12"> <v-select label="사유" v-model="form.claimReason" :items="['단순 변심', '상품 불량', '기타']" v-bind="attrs_input" /> </v-col>
                    <v-col cols="12"> <v-textarea label="상세" v-model="form.claimReasonDetails" v-bind="attrs_input" /> </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn text @click="shows = false">취소</v-btn>
                <v-btn color="primary" text @click="put">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { attrs_input, PURCHASE_CLAIM_STATUSES, PURCHASE_PURCHASE_STATUSES } from "@/assets/variables";

const initForm = () => ({
    claimReason: null,
    claimReasonDetails: null,
});

export default {
    props: {
        loading: { type: Boolean, default: false },
        selected: { type: Array, default: () => [] },
    },
    data: () => ({
        form: initForm(),

        shows: false,
        attrs_input,
    }),
    mounted() {
        this.init();
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
    methods: {
        init() {
            this.form = initForm();
        },
        async put() {
            if (this.loading) return;
            else this.$emit("loading", true);

            try {
                if (!this.selected.length) throw new Error("교환요청 처리할 구매건을 선택해주세요");

                const { claimReason, claimReasonDetails } = this.form;
                for (const { _id } of this.selected) {
                    await api.console.shop.purchases.putPurchase({ _id, claimReason, claimReasonDetails, claimStatus: PURCHASE_CLAIM_STATUSES.EXCHANGE_REQUESTED.value, purchaseStatus: PURCHASE_PURCHASE_STATUSES.PURCHASE_PENDING.value, rejectedAt: null, canceledAt: null, returnedAt: null, exchangedAt: null, exchangeShippedAt: null });
                }

                alert("교환요청 처리 되었습니다");
                this.shows = false;
            } catch (error) {
                this.$handleError(error);
            } finally {
                this.$emit("loading", false);
                this.$emit("search");
            }
        },
    },
};
</script>

<style></style>
